import { palette, Typography } from '@dev/ee-components';
import styled from 'styled-components';

export const FilterContainer = styled.div`
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
`;

export const FilterLabel = styled.span`
    margin: 0;
    display: flex;
    align-items: center;
    flex: 1;
    & + .MuiChip-root {
        margin-left: 12px;
    }
`;

export const EventFilterWrapper = styled.div<{ hasMessageCategory: boolean }>`
    .MuiPaper-root:first-of-type {
        width: 100%;
        min-width: 250px;
        display: inline-grid;
    }
    .optionWithCheckbox,
    .MuiAccordionSummary-root {
        &:hover {
            background: ${palette.indigo[1]};
        }
    }
    ${({ hasMessageCategory }) =>
        !hasMessageCategory &&
        `
        .optionWithCheckbox {
            .optionTag {
                margin-right: 12px;
            }
        }
       
    `}
`;

export const StyledVisibilityIcon = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    &:hover {
        cursor: pointer;
        position: relative;
        &::before {
            content: '';
            position: absolute;
            z-index: 2;
            width: 32px;
            height: 32px;
            right: -5px;
            background-color: ${palette.indigo[1]};
            border-radius: 20px;
        }
    }
    & svg {
        font-size: 22px;
        z-index: 2;
        fill: #718096;
    }
`;

export const EmailCell = styled.div<{ clickable: boolean }>`
    ${({ clickable }) =>
        clickable &&
        `
    &:hover {
        text-decoration: underline;
        cursor: pointer;
    }
    `}
`;

export const LogsError = styled.span<{ clickable?: boolean }>`
    cursor: pointer;
    ${({ clickable }) =>
        clickable &&
        `
    text-decoration: underline;
    `}
    &:hover {
        text-decoration: underline;
    }
`;
export const HelpFont = styled<any>(Typography)`
    font-size: 11px;
`;

export const TrimLengthWrapper = styled.div`
    button,
    & > div {
        &,
        &:hover,
        &:focus {
            max-width: 150px;
        }
    }
`;
